import HtmlTrans from 'components/shared/HtmlTrans';
import { Heading1 } from 'components/shared/Typography';
import { useI18n } from 'hooks/useI18n';
import { METHODOLOGYSECTIONS } from './Methodology.constants';
import {
  StyledContainer,
  StyledDesc,
  StyledThanks,
  StyledWrapper
} from './Methodology.styled';
import MethodologySection from './MethodologySection';

const Methodology: React.FC = () => {
  const { t } = useI18n('developer-career-report-2023');
  const sections = METHODOLOGYSECTIONS(t);

  return (
    <StyledWrapper>
      <StyledContainer>
        <Heading1 editorial alignLeft as="h5">
          {t('mandecar23.methodology.title')}
        </Heading1>
        <StyledDesc>
          <HtmlTrans
            ns="developer-career-report-2023"
            i18nKey="mandecar23.methodology.desc"
          />
        </StyledDesc>
        {sections.map((section, index) => (
          <MethodologySection
            key={index}
            title={section.title}
            desc={section.desc}
            chart={section.chart}
            accordion={section.accordion}
          />
        ))}
        <StyledThanks>
          <HtmlTrans
            ns="developer-career-report-2023"
            i18nKey="mandecar23.methodology.thanks"
          />
        </StyledThanks>
      </StyledContainer>
    </StyledWrapper>
  );
};

export default Methodology;
